import { Router } from "@solidjs/router";
import { render } from "solid-js/web";
import { App } from "./App.tsx";
import { AuthProvider } from "./auth/AuthContext.tsx";
import { MountPointNotFoundError } from "./errors/index.ts";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new MountPointNotFoundError("#root");

// AuthProvider wraps all routes via the Router `root` layout so `useAuth` is
// available in both the login screen and the protected shell.
render(
  () => <Router root={(props) => <AuthProvider>{props.children}</AuthProvider>}>{App()}</Router>,
  root,
);
